import { Controller } from "@hotwired/stimulus"

// Records which date-range-picker preset (Last Week, This Month, ...) the user
// picked, as a token in a hidden `date_preset` field, so a saved view can store
// the preset instead of the dates it meant that day. Sits on the filter form;
// the date input dispatches `change` after the picker's apply and after Clear
// (see date_range_picker_controller.js). A custom range or a cleared field
// leaves the token blank and the server falls back to the fixed dates.
export default class extends Controller {
  static targets = ["input", "preset"]

  sync() {
    this.presetTarget.value = this.#chosenToken()
  }

  #chosenToken() {
    if (!this.inputTarget.value) return ""
    const label = this.application.getControllerForElementAndIdentifier(this.inputTarget, "date-range-picker")?.chosenLabel
    if (!label) return ""
    return label.trim().toLowerCase().replace(/\s+/g, "_")
  }
}
